//
//
//
//
//
//
//

import createHead from './headList.js';
import viewportMixin from '@/mixins/viewport.mixin';
import filterMixin from '@/mixins/filter';

import PageLayout from '@/components/autoscale/pageLayout.vue';
import SectionTop from '@/pages/webinars/components/sectionTop.vue';
import SectionCards from '@/pages/webinars/components/sectionCards.vue';

export default {
  name: 'EventsList',
  components: { PageLayout, SectionTop, SectionCards },
  mixins: [filterMixin, viewportMixin],
  layout: 'scaled',
  meta: {
    show: ['br', 'mx'],
  },
  middleware: ['eventDirections'],
  data() {
    return {
      filterNamespace: '',
    };
  },
  head() {
    const createHeadFunction = createHead.bind(this);
    return createHeadFunction();
  },
  mounted() {
    this.filterNamespace = 'eventList';
  },
};
